import React from "react"

import { css } from "@emotion/react"

import { NIRVANA_COLORS } from "../config/theme.config.ts"
import { PrimaryText } from "./primaryText.element"

export const FixedTopRightActionElement: React.FunctionComponent<
    IFixedHeaderActionElementProps
> = props => {
    return (
        <div css={styles.container} className={props.className}>
            {props.additionalLabel ? (
                <PrimaryText>{props.additionalLabel}&nbsp;</PrimaryText>
            ) : null}

            {props.ctaUrl ? (
                <a
                    href={props.ctaUrl}
                    target={props.isExternalUrl ? "_blank" : undefined}
                    rel={
                        props.isExternalUrl ? "noopener noreferrer" : undefined
                    }
                >
                    <PrimaryText
                        underline
                        typography="textSemibold"
                        className={props.ctaLabelClassName}
                    >
                        {props.ctaLabel}
                    </PrimaryText>
                </a>
            ) : null}

            {props.ctaAction ? (
                <div onClick={props.ctaAction}>
                    <PrimaryText
                        underline
                        typography="textSemibold"
                        className={props.ctaLabelClassName}
                        css={styles.ctaAction}
                    >
                        {props.ctaLabel}
                    </PrimaryText>
                </div>
            ) : null}
        </div>
    )
}

const styles = {
    container: css({
        position: "fixed",
        top: 46,
        right: 50,
        display: "flex",
        alignItems: "center",
    }),
    ctaAction: css({
        cursor: "pointer",
        color: NIRVANA_COLORS.brand.primary,
    }),
}

interface IFixedHeaderActionElementProps {
    className?: string
    ctaLabel: string
    ctaLabelClassName?: string
    ctaUrl?: string
    isExternalUrl?: boolean
    ctaAction?: () => void
    additionalLabel?: string
}
